import { ModuleWithProviders, NgModule } from '@angular/core';
import { MarkdownParser, TemplateRenderer } from '@libs/libraries/shared';
import { Validator } from '@libs/utilities/validator';

import { EnumLegalInjectionToken, ILegalPagesConfig, LegalPagesConfigSchema } from '../../components/legal-pages/legal-pages.interface';
import { LegalContentGenerator } from './legal-content-generator/legal-content-generator';
import { LegalTextParser } from './legal-text-parser/legal-text-parser';


/** Shares legal content rendering without registering application routes. */
@NgModule({
	providers: [TemplateRenderer, MarkdownParser, LegalTextParser, LegalContentGenerator]
})
export class LegalContentModule {
	static register(config: ILegalPagesConfig): ModuleWithProviders<LegalContentModule> {
		if (!Validator.Schema.isValid(config, LegalPagesConfigSchema)) {
			throw new Error(`LegalContentModule => register => Invalid legal configuration: ${Validator.Schema.validationMessages(config, LegalPagesConfigSchema).join(', ')}`);
		}

		return {
			ngModule: LegalContentModule,
			providers: [{ provide: EnumLegalInjectionToken.Config, useValue: config }]
		};
	}
}
